addEventListener("DOMContentLoaded", (event) => {
  console.log('-- custom javascript loaded --')
  
  const moneyFormat = '${{amount}}';
  var headerConfigs = {
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "xmlhttprequest",
    },
  };
  
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
  
    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ',',
      decimal = '.'
    ) {
      if (isNaN(number) || number == null) {
        return 0;
      }
  
      number = (number / 100.0).toFixed(precision);
  
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';
  
      return dollarsAmount + centsAmount;
    }
  
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  }
  
  async function getCart() {
    var response = await fetch(`${window.Shopify.routes.root}cart.js`)
    
    if (!response.ok) {
      console.log('response: ', response)
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    var data = await response.json()
    return data
  }
  
  async function updateCart(updates) {
    console.log('updates: ', `${window.Shopify.routes.root}cart/update.js`, {
      updates: updates
    });

    var response = await fetch(`${window.Shopify.routes.root}cart/update.js`, Object.assign(headerConfigs, {
      method: "POST",
      body: JSON.stringify({
        updates: updates
      })
    }))
    
    if (!response.ok) {
      console.log('response: ', response)
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    var data = await response.json()
    return data
  }
  
  async function changeItemsInCart(changes) {
    var response = await fetch(`${window.Shopify.routes.root}cart/change.js`, Object.assign(headerConfigs, {
      method: "POST",
      body: JSON.stringify(changes)
    }))
    
    if (!response.ok) {
      console.log('response: ', response)
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    var data = await response.json()
    return data
  }

  var productForms = Array.from(document.querySelectorAll('[data-product-form'));
  
  if (productForms.length > 0) {
    productForms.forEach(form => {
      var variantSelect = form.querySelector('.variant-select');  
      var frameUpsells = form.querySelectorAll('[data-frame-variant]');
      var selectedVariant = variantSelect.options[variantSelect.selectedIndex].dataset.value;
      var addToCartForm = form.querySelector('#add-to-cart-form');
      var linkedFrame = addToCartForm.querySelector('[data-props-linked-frame]')
      var linkedVariant = addToCartForm.querySelector('[data-props-linked-variant]')
      var linkedSku = addToCartForm.querySelector('[data-props-linked-sku]')
  
      var showEligibleFrameUpsellOnLoad = (selectedVariant) => {
        /**
        Immediately hide all frame upsells.
        */
        frameUpsells.forEach(upsell => {
        const framesOuterDiv = upsell.querySelector('.frames-outer');
        if (framesOuterDiv) {
        framesOuterDiv.style.display = 'none';
        }
        });

        if (!selectedVariant) return;
        
        var selectedFrameUpsell = form.querySelector("[data-frame-variant='" +  selectedVariant + "']");
  
        if (selectedFrameUpsell && selectedFrameUpsell.querySelector('.child-variants') && !selectedFrameUpsell.classList.contains('soldout')) 
        {
          const deaultValue = selectedFrameUpsell.querySelector('[value="unframed-print-only"]');
          
          const framesOuterDiv = selectedFrameUpsell.querySelector('.frames-outer');
          if (framesOuterDiv) {
          framesOuterDiv.style.display = 'block';
          }
          
          if (deaultValue) {
            deaultValue.checked = true
          }
        }
      }
    
      var resetFrameSelectionToNothing = (inputs) => {
        var frameInputs = addToCartForm.querySelectorAll('[data-frame-value]')
        frameInputs.forEach(frame => frame.checked = false)
        inputs.linkedFrame.value = ''
        inputs.linkedVariant.value = ''
        inputs.linkedSku.value = ''
        inputs.linkedTitle.value = ''
      }
    
      var updateEligibleFrameSelection = (selectedFrame, formInputs) => {
        if (!selectedFrame) return;
        
        var selectedFrameUpsell = document.querySelector("[data-frame-variant='" +  selectedFrame + "']");
        
           frameUpsells.forEach(upsell => {
        const framesOuterDiv = upsell.querySelector('.frames-outer');
        if (framesOuterDiv) {
        framesOuterDiv.style.display = 'none';
        }
        });
        
        resetFrameSelectionToNothing(formInputs)
        
        if (selectedFrameUpsell && selectedFrameUpsell.querySelector('.child-variants') && !selectedFrameUpsell.classList.contains('soldout')) {
          const deaultValue = selectedFrameUpsell.querySelector('[value="unframed-print-only"]')
          
            const framesOuterDiv = selectedFrameUpsell.querySelector('.frames-outer');
          if (framesOuterDiv) {
          framesOuterDiv.style.display = 'block';
          }  
          
          if (deaultValue) {
            deaultValue.checked = true
          }
        }
      }
      
      function selectedFormInputs(target) {
        var comparePrice = addToCartForm.querySelector('[data-compare-price]');
        var priceElement = addToCartForm.querySelector('[data-price]');
        
        return {
          linkedFrame: target.querySelector('[data-props-linked-frame]'),
          linkedVariant: target.querySelector('[data-props-linked-variant]'),
          linkedSku: target.querySelector('[data-props-linked-sku]'),
          linkedTitle: target.querySelector('[data-props-linked-title]'),
          frameUpsell: target.querySelectorAll('[data-frame-value]:checked').length > 0 ? target.querySelectorAll('[data-frame-value]:checked')[0] : null,
          comparePriceEl: comparePrice,
          priceElementEl: priceElement,
          originalPrice: Number(priceElement.dataset.price),
          compareAtPrice: comparePrice ? Number(comparePrice.dataset['comparePrice']) : 0,
        }
      }
      
      function updatePricingDisplay(inputs) {
        
        function generateNewPrice(original, upsell) {
          return   Number(original) + Number(upsell)
        }
        
        var innerSpanContent = '<span class="sr-only">Your Cart Subtotal</span>'
        var originalPriceElement = inputs.priceElementEl.querySelector('.money')
        const closest = inputs.frameUpsell.closest(".frame-option");
              
        if (!inputs.frameUpsell || inputs.frameUpsell.value === 'unframed-print-only') {
          originalPriceElement.innerHTML = innerSpanContent + formatMoney(inputs.originalPrice);
          closest.querySelector('.frame-price').innerHTML = formatMoney(inputs.originalPrice);
        } else {
          var frameUpsellPrice = inputs.frameUpsell.dataset.price
          originalPriceElement.innerHTML = innerSpanContent + formatMoney(generateNewPrice(inputs.originalPrice, frameUpsellPrice));
          closest.querySelector('.frame-price').innerHTML = formatMoney(generateNewPrice(inputs.originalPrice, frameUpsellPrice));
        }
        
        if (inputs.compareAtPrice > 0) {
          var compareAtPriceElement = inputs.comparePriceEl.querySelector('.money')
          var frameUpsellPrice = inputs.frameUpsell.dataset.price
          compareAtPriceElement.innerHTML = innerSpanContent + formatMoney(generateNewPrice(inputs.compareAtPrice, frameUpsellPrice))
        }
      }
      
      /**
       * Hidden inputs necessary for the 
       * frame upsell data to be passed to the cart
       */
      function updateFrameDataInputs(inputs) {
        /**
         * Unframed Upsell Selection
         */
        if (!inputs.frameUpsell || inputs.frameUpsell.value === 'unframed-print-only') {
          inputs.linkedFrame.value = ''
          inputs.linkedVariant.value = ''
          inputs.linkedSku.value = ''
          inputs.linkedTitle.value = ''
        } else {
          inputs.linkedFrame.value = inputs.frameUpsell.dataset.frameValue
          inputs.linkedVariant.value = inputs.frameUpsell.value
          inputs.linkedSku.value = inputs.frameUpsell.dataset.sku
          inputs.linkedTitle.value = inputs.frameUpsell.dataset.frameTitle
        }
      }
    
      var formChange = (e) => {
        var selectedInputs = selectedFormInputs(e.currentTarget)
        var tagType = e.target.tagName
        
        if (tagType === 'INPUT') {
          updatePricingDisplay(selectedInputs)  
          updateFrameDataInputs(selectedInputs)
        } else {
          var variantSelector = form.querySelector('.variant-select');
          var variantSelectedValue = variantSelector.options[variantSelect.selectedIndex].dataset.value
          
          updateEligibleFrameSelection(variantSelectedValue, selectedInputs)
        }
      }
      
      showEligibleFrameUpsellOnLoad(selectedVariant)
      addToCartForm.addEventListener('change', formChange);
    })
  }
  
  var initSwipers = () => {
    console.log('-- init swipers --')
    var swipers = Array.from(document.querySelectorAll('.pl-swiper'));

    if (swipers.length > 0) {
      swipers.forEach(swiper => {
        new Swiper(swiper, {
          slidesPerView: 1.5,
          spaceBetween: 10,
          freeMode: true,
          slidesOffsetAfter: 50,
          slidesOffsetBefore: 50,
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
              slidesOffsetAfter: 100,
              slidesOffsetBefore: 100,
            },
          },
          mousewheel: {
            releaseOnEdges: true,
            forceToAxis: true,
          },
          navigation: {
            nextEl: swiper.querySelector(".swiper-button-next"),
            prevEl: swiper.querySelector(".swiper-button-prev"),
          },
        });
      }) 
    }
  }

  initSwipers();

  var customCartListeners = async () => {
    /**
    * Update to the following:
    * 1. If bundled print is removed → remove all bundled items
    * 2. If frame is removed, only remove frame, not all items. 
    */
    if (window.location.pathname.includes('cart'))  {
      var cartForm = document.querySelector('#cartform');
      if (!cartForm) return;
      
      cartForm.addEventListener('click', async (e) => {
        /**
         * 1. If print is removed
         *  - Remove print & frame
         * 2. If frame is removed
         *  - Remove frame and remove custom properties from the print. 
         * 
         * 
         * 
         * 
         * 
         */
        if (e.target.tagName === 'A' && e.target.hasAttribute('data-cart-action-remove') && e.target.hasAttribute('data-bundle-id')) {
          e.preventDefault()
          var updateRequest = null
          var cartItems = await getCart();
          var productJson = JSON.parse(e.target.previousElementSibling.innerHTML)
          var bundledItems = cartItems.items.filter(item => item.properties && (item.properties['_bundleId'] === e.target.dataset.bundleId))
          var mappedPayload = bundledItems.reduce((acc, i) => {
            console.log('item in mapped: ', i)
            acc[i.key] = 0;
            return acc;
          }, {});
          
          if (productJson.product_type === 'Framing') {
            var productsAssociatedToFrames = bundledItems.filter(item => item.product_type !== 'Framing')
            var frames = bundledItems.filter(item => item.product_type === 'Framing').reduce((acc, i) => {
              console.log('item in mapped: ', i)
              acc[i.key] = 0;
              return acc;
            }, {});

            /**
             * Create an array of async functions to be called within the promise. 
             */
            const asyncProductChanges = productsAssociatedToFrames.map((product) => {
              return new Promise((resolve, reject) => {
                try {
                  var changes = changeItemsInCart({
                    'id': product.key,
                    'properties': {}
                  })
                  resolve(changes)
                } catch(e) {
                  reject(e)
                }
              });
            })
            
            await Promise.all(asyncProductChanges);
            updateRequest = await updateCart(frames)
          } 
          
          if (productJson.product_type !== 'Framing') {
            console.log('this is fine art', mappedPayload)
            /**
             * Remove all bundled products
             */
            updateRequest = await updateCart(mappedPayload)
          } 

          if (updateRequest)  {
            window.location.reload()
          }

        } else {
          return true
        }
      })    
    }
  }
  
  customCartListeners()
 
});


$('input[type="radio"][name="radio-id"]').on('change', function() {
  var dataIndex = $(this).closest('.frame-option').attr('data-index');
  var dataFrame = $(this).closest('.frame-option').attr('data-frame-variant');
  var SelectToClick = $(document).find('.product-option-select select option[data-value="'+dataFrame+'"]').val();
  var select = document.querySelector('.product-option-select select');
    select.value = SelectToClick;
    select.dispatchEvent(new Event('change'));
});
